import SelectMappingMethodBody from "@/pages/projects/forms/create/components/steps/select-mapping-method/SelectMappingMethodBody";

const ProjectSelectMappingMethodStep = () => {
  return <SelectMappingMethodBody />;
};

export default ProjectSelectMappingMethodStep;
